import { RecordStatus } from "../api/models/RecordStatus";

export const getStattus = (status: RecordStatus) => {
    if (status === RecordStatus.Processing) {
        return "файл обрабатывается";
    }
    if (status === RecordStatus.Available) {
        return "файл доступен";
    }
    return "файл недоступен";
}

/**
 * Склонение числительных
 * @param n число
 * @param text_forms склонения
 * @returns
 */
export const declOfNum = (n: number, text_forms: string[]) => {
    n = Math.abs(n) % 100;
    const n1 = n % 10;
    if (n > 10 && n < 20) { return text_forms[2]; }
    if (n1 > 1 && n1 < 5) { return text_forms[1]; }
    if (n1 === 1) { return text_forms[0]; }
    return text_forms[2];
}

export function isGuid(value: string): boolean {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value);
}

export function splitLongWords(text: any, maxLength = 48) {
    if (text.includes("href")) {
        return text;
    }
    return text
        .split(/\s+/)
        .map((word: any) => {
            if (word.length <= maxLength) return word;
            const chunks = [];
            for (let i = 0; i < word.length; i += maxLength) {
                chunks.push(word.slice(i, i + maxLength));
            }
            return chunks.join('\n');
        })
        .join(' ');
}

export function isMobile() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}